import React from 'react';
import { LanguageProvider } from './i18n/LanguageContext';
import { UserLanguageProvider } from './i18n/UserLanguageContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Welcome from './screens/Welcome';
import LanguagePicker from './screens/LanguagePicker';
import TargetLanguage from './screens/TargetLanguage';
import Goal from './screens/Goal';
import PathChooser from './screens/PathChooser';
import PlacementTest from './screens/PlacementTest';
import BeginnerConfirm from './screens/BeginnerConfirm';
import ChooseLevel from './screens/ChooseLevel';
import SignUp from './screens/SignUp';
import SignIn from './screens/SignIn';
import Home from './screens/Home';
import './App.css';
import Topics from './screens/Topics';
import WordBank from './screens/WordBank';
import Games from './screens/Games';
import Profile from './screens/Profile';
import TopicDetail from './screens/TopicDetail';
import Lesson from './screens/Lesson';
import LessonResults from './screens/LessonResults';
import WordSearch from './screens/WordSearch';
import WordWheel from './screens/WordWheel';
import FlashcardSprint from './screens/FlashcardSprint';
import Crossword from './screens/Crossword';
import Anagram from './screens/Anagram';
import TranslationSprint from './screens/TranslationSprint';
import Luna from './screens/Luna';
import Stories from './screens/Stories';
import Sentences from './screens/Sentences';
import Vocabulary from './screens/Vocabulary';
import Pronunciation from './screens/Pronunciation';
import AddLanguage from './screens/AddLanguage';
import StoryReader from './screens/StoryReader';
import Grammar from './screens/Grammar';
import VerbDetail from './screens/VerbDetail';

function App() {
  return (
    <LanguageProvider>
      <UserLanguageProvider>
        <BrowserRouter>
          <div className="app-container">
            <Routes>
              <Route path="/" element={<Welcome />} />
              <Route path="/language" element={<LanguagePicker />} />
              <Route path="/onboarding/target-language" element={<TargetLanguage />} />
              <Route path="/onboarding/goal" element={<Goal />} />
              <Route path="/onboarding/path" element={<PathChooser />} />
              <Route path="/onboarding/placement-test" element={<PlacementTest />} />
              <Route path="/onboarding/beginner-confirm" element={<BeginnerConfirm />} />
              <Route path="/onboarding/choose-level" element={<ChooseLevel />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/home" element={<Home />} />
              <Route path="/topics" element={<Topics />} />
              <Route path="/wordbank" element={<WordBank />} />
              <Route path="/games" element={<Games />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/topic/:topicSlug" element={<TopicDetail />} />
              <Route path="/lesson/:lessonSlug" element={<Lesson />} />
              <Route path="/results/:topicSlug/:lessonSlug" element={<LessonResults />} />
              <Route path="/games/word-search" element={<WordSearch />} />
              <Route path="/games/word-wheel" element={<WordWheel />} />
              <Route path="/games/flashcard-sprint" element={<FlashcardSprint />} />
              <Route path="/games/crossword" element={<Crossword />} />
              <Route path="/games/anagram" element={<Anagram />} />
              <Route path="/games/translation-sprint" element={<TranslationSprint />} />
              <Route path="/luna/:topicSlug" element={<Luna />} />
              <Route path="/stories" element={<Stories />} />
              <Route path="/sentences" element={<Sentences />} />
              <Route path="/vocabulary" element={<Vocabulary />} />
              <Route path="/pronunciation" element={<Pronunciation />} />
              <Route path="/add-language" element={<AddLanguage />} />
              <Route path="/story/:storySlug" element={<StoryReader />} />
              <Route path="/grammar" element={<Grammar />} />
              <Route path="/verb/:verbSlug" element={<VerbDetail />} />
            </Routes>
          </div>
        </BrowserRouter>
      </UserLanguageProvider>
    </LanguageProvider>
  );
}

export default App;